<template>
  <v-container>
    <!-- Button for displaying the upload component -->
    <v-btn @click="uploadDialog = true" icon>
        <v-icon size="30">mdi-plus</v-icon>
    </v-btn>

    <Upload :dialog.sync="uploadDialog" />
  </v-container>
</template>

<script>
import Uploade from "./Uploade";
export default { 
  name: "Home",
  
  components: { Uploade },
  data(){
    return{
      uploadDialog:false
    }
  }
};
</script>